import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M2_Functions = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Functions in C (Pass by Value and Pass by Reference)"
    videos={[
      "https://www.youtube.com/embed/SK5gBnwN4dg", // Add two numbers using function
      "https://www.youtube.com/embed/xnY247NB6_g", // Types of functions
      "https://www.youtube.com/embed/aaauDeLq74g", // Pass by value and pass by reference
    ]}
    takeaways={[
      { text: "Expect theory-based questions from this part." },
      { text: "Understand the definition and advantages of functions." },
      {
        text: "Learn the main difference between call by value and call by reference.",
      },
      {
        text: "Know the types of functions classified based on return type and parameters.",
      },
      {
        text: "Understand the concept of inline functions, including their definition and advantages.",
      },
    ]}
    questions={[
      "Explain the difference between call by reference and call by value with examples.",
      "Given a code with both call by reference and call by value parameters, determine the values of parameters after function execution.",
      "Write recursive functions for problems like Fibonacci series, factorial, or sum of n numbers.",
      "Write a function to solve a given mathematical expression or problem.",
    ]}
    exampleVideos={[]} // No extra example videos for now
  />
);
}

export default OOPS_M2_Functions;
